import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { LoadingController, Platform } from "ionic-angular";
import { AppSettings } from './app-settings'
// import {Storage} from '@ionic/storage';

import { HttpParams, HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Http, RequestOptions } from '@angular/http';


@Injectable()
export class ServerService {
    adruncount: any = 0;
    adruncount2: any = 0;
    appServerURL: any = AppSettings.SERVER_URL;
    constructor(public loadingCtrl: LoadingController,
        // public storage: Storage,
        private plat: Platform,
        private http: Http) { }



    auth(url, merkaz, username, password) {
        // let loading = this.loadingCtrl.create({ content: 'Please wait...' });
        // loading.present();

        let isRamatGanServer: string = "0";
        if (merkaz == "בית עמנואל") {
            isRamatGanServer = "1";
        }


        try {
            var firstHeaders = new Headers();
            firstHeaders.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

            const headers = new HttpHeaders();
            headers.set('Content-Type', 'application/json; charset=utf-8');

            let body = new FormData();
            body.append("mercazName", decodeURIComponent(merkaz));
            body.append("userName", decodeURIComponent(username));
            body.append("password", password);
            body.append("push", localStorage.getItem('push'));
            body.append("isRamatGanServer", isRamatGanServer);
            return this.http.post(AppSettings.SERVER_URL + '' + url, body).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
            // loading.dismiss();
        }
    }

    // AuthPostRequest(url, data) {
    //     let loading = this.loadingCtrl.create({ content: 'Please wait...' });
    //     loading.present();
    //     try {
    //         let body = new FormData();
    //         body.append("data", JSON.stringify(data));
    //         body.append("from_app", "1");
    //         return this.http.post( this.appServerURL + '' + url, body).map(res => res.json()).do((data) => {
    //         }).toPromise();
    //     } catch (err) {
    //         console.log(err);
    //     } finally {
    //         loading.dismiss();
    //     }
    // }

    getEvents(url, merkaz, username, password, showAllEvents) {
        // let loading = this.loadingCtrl.create({ content: 'Please wait...' });
        // loading.present();

        let isRamatGanServer: string = "0";
        let beitEmonoalRamatGanServer = localStorage.getItem("beitEmonoalRamatGanServer");
        if (beitEmonoalRamatGanServer == "1") {
            isRamatGanServer = "1";
        }


        try {
            var firstHeaders = new Headers();
            firstHeaders.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

            const headers = new HttpHeaders();
            headers.set('Content-Type', 'application/json; charset=utf-8');

            let body = new FormData();
            body.append("mercazName", decodeURIComponent(merkaz));
            body.append("userName", decodeURIComponent(username));
            body.append("password", password);
            body.append("pqpq", localStorage.getItem('server'));
            body.append("push", localStorage.getItem('push'));
            body.append("user_id", localStorage.getItem('user_id'));
            body.append("mercazAllId", localStorage.getItem('mercazAllId'));
            body.append("showAllEvents", showAllEvents);
            body.append("isRamatGanServer", isRamatGanServer);
            return this.http.post(AppSettings.SERVER_URL + '' + url, body).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
            // loading.dismiss();
        }

    }


    getEventTickets(url, merkaz, username, password, eventId, Scanned,
        personal_firstname,
        personal_lastname,
        personal_mobile,
        personal_cc,
        event_row,
        event_chainnum,
        personal_reciptnumber) {
        // let loading = this.loadingCtrl.create({ content: 'Please wait...' });
        // loading.present();

        let isRamatGanServer: string = "0";
        let beitEmonoalRamatGanServer = localStorage.getItem("beitEmonoalRamatGanServer");
        if (beitEmonoalRamatGanServer == "1") {
            isRamatGanServer = "1";
        }

        try {
            var firstHeaders = new Headers();
            firstHeaders.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

            const headers = new HttpHeaders();
            headers.set('Content-Type', 'application/json; charset=utf-8');

            let body = new FormData();
            body.append("mercazName", decodeURIComponent(merkaz));
            body.append("userName", decodeURIComponent(username));
            body.append("password", password);
            body.append("eventId", eventId);
            body.append("scanned", Scanned);
            body.append("pqpq", localStorage.getItem('server'));
            body.append("push", localStorage.getItem('push'));
            body.append("isRamatGanServer", isRamatGanServer);
            body.append("personal_firstname", decodeURIComponent(personal_firstname));
            body.append("personal_lastname", decodeURIComponent(personal_lastname));
            body.append("personal_mobile", personal_mobile);
            body.append("personal_cc", personal_cc);
            body.append("event_row", event_row);
            body.append("event_chainnum", event_chainnum);
            body.append("personal_reciptnumber", personal_reciptnumber);
            body.append("mercazAllId", localStorage.getItem('mercazAllId'));

            return this.http.post(AppSettings.SERVER_URL + '' + url, body).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
            // loading.dismiss();
        }

    }


    updateTicketStatus(url, merkaz, username, password, ticketId, invoiceNumber, ticketCheck) {
        // let loading = this.loadingCtrl.create({ content: 'Please wait...' });
        // loading.present();

        let isRamatGanServer: string = "0";
        let beitEmonoalRamatGanServer = localStorage.getItem("beitEmonoalRamatGanServer");
        if (beitEmonoalRamatGanServer == "1") {
            isRamatGanServer = "1";
        }


        try {
            var firstHeaders = new Headers();
            firstHeaders.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

            const headers = new HttpHeaders();
            headers.set('Content-Type', 'application/json; charset=utf-8');

            let body = new FormData();
            body.append("mercazName", decodeURIComponent(merkaz));
            body.append("userName", decodeURIComponent(username));
            body.append("password", password);
            body.append("ticketId", ticketId);
            body.append("invoiceNumber", invoiceNumber);
            body.append("activated", ticketCheck);
            body.append("pqpq", localStorage.getItem('server'));
            body.append("push", localStorage.getItem('push'));
            body.append("mercazAllId", localStorage.getItem('mercazAllId'));
            body.append("isRamatGanServer", isRamatGanServer);
            return this.http.post(AppSettings.SERVER_URL + '' + url, body).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
            // loading.dismiss();
        }

    }


    updateTicketMultiStatus(url, merkaz, username, password, ticketCheck, tickets) {
        // let loading = this.loadingCtrl.create({ content: 'Please wait...' });
        // loading.present();

        let isRamatGanServer: string = "0";
        let beitEmonoalRamatGanServer = localStorage.getItem("beitEmonoalRamatGanServer");
        if (beitEmonoalRamatGanServer == "1") {
            isRamatGanServer = "1";
        }

        try {
            var firstHeaders = new Headers();
            firstHeaders.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

            const headers = new HttpHeaders();
            headers.set('Content-Type', 'application/json; charset=utf-8');

            let body = new FormData();
            body.append("mercazName", decodeURIComponent(merkaz));
            body.append("userName", decodeURIComponent(username));
            body.append("password", password);
            body.append("activated", ticketCheck);
            body.append("tickets", JSON.stringify(tickets));
            body.append("pqpq", localStorage.getItem('server'));
            body.append("push", localStorage.getItem('push'));
            body.append("mercazAllId", localStorage.getItem('mercazAllId'));
            body.append("isRamatGanServer", isRamatGanServer);
            return this.http.post(AppSettings.SERVER_URL + '' + url, body).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
            // loading.dismiss();
        }

    }


    scanQRParams(url, merkaz, username, password, params) {
        // let loading = this.loadingCtrl.create({ content: 'Please wait...' });
        // loading.present();

        let isRamatGanServer: string = "0";
        let beitEmonoalRamatGanServer = localStorage.getItem("beitEmonoalRamatGanServer");
        if (beitEmonoalRamatGanServer == "1") {
            isRamatGanServer = "1";
        }


        try {
            var firstHeaders = new Headers();
            firstHeaders.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

            const headers = new HttpHeaders();
            headers.set('Content-Type', 'application/json; charset=utf-8');

            let body = new FormData();
            body.append("mercazName", decodeURIComponent(merkaz));
            body.append("userName", decodeURIComponent(username));
            body.append("password", password);
            body.append("pqpq", localStorage.getItem('server'));
            body.append("params", JSON.stringify(params));
            body.append("push", localStorage.getItem('push'));
            body.append("mercazAllId", localStorage.getItem('mercazAllId'));
            body.append("isRamatGanServer", isRamatGanServer);
            return this.http.post(AppSettings.SERVER_URL + '' + url, body).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
            // loading.dismiss();
        }

    }


    sendPostParams(url, params) {
        // let loading = this.loadingCtrl.create({ content: 'Please wait...' });
        // loading.present();

        let isRamatGanServer: string = "0";
        let beitEmonoalRamatGanServer = localStorage.getItem("beitEmonoalRamatGanServer");
        if (beitEmonoalRamatGanServer == "1") {
            isRamatGanServer = "1";
        }

        try {
            // var firstHeaders = new Headers();
            // firstHeaders.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

            // const headers = new HttpHeaders();
            // headers.set('Content-Type', 'application/json; charset=utf-8');

            let body = new FormData();
            body.append("params", JSON.stringify(params));
            body.append("mercazAllIdApp", localStorage.getItem('mercazAllId'));
            body.append("isRamatGanServer", isRamatGanServer);
            return this.http.post(AppSettings.SERVER_URL + '' + url, body).map(res => res.json()).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
            // loading.dismiss();
        }

    }

    sendPostParamsAuth(url, merkaz, username, password, params) {

        let isRamatGanServer: string = "0";
        let beitEmonoalRamatGanServer = localStorage.getItem("beitEmonoalRamatGanServer");
        if (beitEmonoalRamatGanServer == "1") {
            isRamatGanServer = "1";
        }

        try {
            let body = new FormData();
            body.append("mercazName", decodeURIComponent(merkaz));
            body.append("userName", decodeURIComponent(username));
            body.append("password", password);
            body.append("pqpq", localStorage.getItem('server'));
            body.append("params", JSON.stringify(params));
            body.append("mercazAllId", localStorage.getItem('mercazAllId'));
            body.append("isRamatGanServer", isRamatGanServer);
            return this.http.post(AppSettings.SERVER_URL + '' + url, body).map(res => res.json()).do((data) => {
            }).toPromise();
        } catch (err) {
            console.log(err);
        } finally {
            // loading.dismiss();
        }

    }






}




//this._categories.next(categories);
//resolve(this.categories);


// WEBPACK FOOTER //
// ./src/services/server-service.ts